/**
 * Reveals the Google sign-in button once the address typed is one Google can
 * actually authenticate — an ICONIC address with no sub-address. Convenience
 * only: the callback checks the domain again, and the password form stays.
 */
const email = document.getElementById('email');
const googleSignIn = document.querySelector('.js-google-sign-in');

if (email && googleSignIn) {
    const domainSuffix = `@${googleSignIn.dataset.iconicEmailDomain}`;

    const update = () => {
        const address = email.value.trim().toLowerCase();
        const localPart = address.endsWith(domainSuffix) ? address.slice(0, -domainSuffix.length) : '';

        // Some accounts are registered under a sub-address (`abc+011@`). Google has no such
        // account, so those addresses only get the password form.
        const isGoogleAddress = localPart.length > 0 && !localPart.includes('+');

        googleSignIn.classList.toggle('d-none', !isGoogleAddress);
    };

    ['input', 'change'].forEach((event) => email.addEventListener(event, update));

    // `old('email')` repopulates the field after a failed attempt.
    update();
}
